const withLocalStorage = fn => (...params) => {
  if (typeof window !== "undefined" && window.localStorage) {
    return fn(...params);
  }
  return null;
};

export const setItem = withLocalStorage((key, value) => {
  localStorage.setItem(key, value);
});

export const removeItem = withLocalStorage(key => {
  localStorage.removeItem(key);
});

export const extractItem = withLocalStorage(key => {
  const value = localStorage.getItem(key);
  localStorage.removeItem(key);

  return value;
});

export default {
  setItem,
  removeItem,
  extractItem
};
